import { c as _c } from "react/compiler-runtime";
interface RecentIconProps {
  size?: number;
  className?: string;
}
const RecentIcon = t0 => {
  const $ = _c(6);
  const {
    size: t1,
    className
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[0] !== size) {
    t2 = {
      width: size,
      height: size
    };
    $[0] = size;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = t2 as React.CSSProperties;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <path d="M9.33315 1.55713C13.6287 1.55713 17.1109 5.03936 17.1109 9.33491C17.1109 13.6304 13.6287 17.1127 9.33315 17.1127C5.0376 17.1127 1.55537 13.6304 1.55537 9.33491H3.11093C3.11093 12.7714 5.89671 15.5571 9.33315 15.5571C12.7696 15.5571 15.5554 12.7714 15.5554 9.33491C15.5554 5.89847 12.7696 3.11268 9.33315 3.11268C7.19443 3.11268 5.30774 4.19173 4.18777 5.83509L6.22204 5.83491V7.39046H1.55537V2.7238H3.11093L3.11084 4.6676C4.52986 2.77882 6.78883 1.55713 9.33315 1.55713ZM10.1109 5.44602L10.1108 9.01213L12.633 11.5348L11.533 12.6347L8.55522 9.65613L8.55537 5.44602H10.1109Z" fill="#767680" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== className || $[4] !== t3) {
    t5 = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 19" fill="none" className={className} style={t3}>{t4}</svg>;
    $[3] = className;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
};
export default RecentIcon;